import { createRouter } from '.'
import { useEventListener } from '@vueuse/core'

/**
 * Create a router for the main app using
 * window.location.
 */
export function createMainRouter() {
    const router = createRouter({
        getParams() {
            return (window.location.hash || '').replace(/^#/, '')
        },
        getQuery(params, delimiter) {
            const query = params.toString().split('&').join(delimiter)
            return `${window.location.search || ''}${query ? `#${query}` : ''}`
        },
        pushState(query) {
            window.history.pushState(
                window.history.state,
                window.document.title,
                window.location.pathname + query
            )
        }
    })

    useEventListener(window, 'popstate', router.onRouteChanged, false)

    return router
}
